<template>
  <div>
    <global-tag>
      <span slot="title">管理</span>
      <div class="search" slot="search">
        <el-form label-width="120px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="姓名：">
                <el-input
                  clearable
                  placeholder="请输入"
                  v-model="searchObj.name"
                  size="primary"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="性别：">
                <el-select
                  placeholder="请选择"
                  v-model="searchObj.sex"
                  size="medium"
                >
                  <el-option label="男" value="0"></el-option>
                  <el-option label="女" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="联系方式：">
                <el-input
                  clearable
                  placeholder="请输入"
                  size="medium"
                  v-model="searchObj.phone"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="用户类型：">
                <el-select v-model="searchObj.customerType">
                  <el-option label="普通客户" value="1"></el-option>
                  <el-option label="老干部服务对象" value="2"></el-option>
                  <el-option label="政府援助客户" value="3"></el-option>
                  <el-option label="D类援助客户" value="4"></el-option>
                  <el-option label="残联服务对象" value="5"></el-option>
                  <el-option label="文明办服务对象" value="6"></el-option>
                  <el-option label="康养用户" value="7"></el-option>
                  <el-option label="军人事务局服务对象" value="8"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="老人所属类别：">
                <el-select v-model="searchObj.elderlyBelongCategory">
                  <el-option label="特困老人" value="1"></el-option>
                  <el-option label="低保老人" value="2"></el-option>
                  <el-option label="建档立卡贫困老人" value="3"></el-option>
                  <el-option label="优抚对象" value="4"></el-option>
                  <el-option label="失独老人" value="5"></el-option>
                  <el-option label="残疾老人" value="6"></el-option>
                  <el-option label="空巢老人" value="7"></el-option>
                  <el-option label="农村留守老人" value="8"></el-option>
                  <el-option label="计划生育特殊家庭成员" value="8"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="2">
              <el-button
                type="primary"
                size="medium"
                class="searchBtns"
                @click="QuerySearch"
                >查询
              </el-button>
              <el-button type="info" icon="el-icon-delete" @click="clearData"
                >清除条件</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
    </global-tag>

    <div class="ele-caozuo">
      <el-button
        type="success"
        size="medium"
        class="openBtns"
        @click="handleTableForm('新增')"
        >新增
      </el-button>
      <!--      <el-button type="primary" size="medium">导入</el-button>-->
      <!--      <el-button type="primary" size="medium">导出</el-button>-->
    </div>

    <div>
      <el-table
        :data="tableData"
        border
        style="width: 100%; margin-bottom: 15px"
        :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
      >
        <el-table-column
          prop="customerName"
          label="姓名"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="gender"
          label="性别"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{ scope.row.gender == 1 ? "女" : "男" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="age"
          label="年龄"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机号码"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="customerType"
          label="用户类型"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope" v-if="scope.row.customerType">
            <span v-if="scope.row.customerType == 1">普通客户</span>
            <span v-else-if="scope.row.customerType == 2">老干部服务对象</span>
            <span v-else-if="scope.row.customerType == 3">政府援助客户</span>
            <span v-else-if="scope.row.customerType == 4">D类援助客户</span>
            <span v-else-if="scope.row.customerType == 5">残联服务对象</span>
            <span v-else-if="scope.row.customerType == 6">文明办服务对象</span>
            <span v-else-if="scope.row.customerType == 7">康养用户</span>
            <span v-else-if="scope.row.customerType == 8"
              >军人事务局服务对象</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="elderlyBelongCategory"
          label="老人所属类别"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.elderlyBelongCategory == 1">特困老人</span>
            <span v-else-if="scope.row.elderlyBelongCategory == 2"
              >低保老人</span
            >
            <span v-else-if="scope.row.elderlyBelongCategory == 3"
              >建档立卡贫困老人</span
            >
            <span v-else-if="scope.row.elderlyBelongCategory == 4"
              >优抚对象</span
            >
            <span v-else-if="scope.row.elderlyBelongCategory == 5"
              >失独老人</span
            >
            <span v-else-if="scope.row.elderlyBelongCategory == 6"
              >残疾老人</span
            >
            <span v-else-if="scope.row.elderlyBelongCategory == 7"
              >空巢老人</span
            >
            <span v-else-if="scope.row.elderlyBelongCategory == 8"
              >农村留守老人</span
            >
            <span v-else-if="scope.row.elderlyBelongCategory == 9"
              >计划生育特殊家庭成员</span
            >
            <span v-else>其他</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <div class="operation-btn">
              <div
                class="operation-color"
                @click="handleTableForm('查看', scope.row.id)"
              >
                查看
              </div>
              <div
                class="operation-color"
                @click="handleTableForm('编辑', scope.row.id)"
              >
                编辑
              </div>
              <div @click="deleteItem(scope.row.id)" class="operation-color">
                删除
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageConfig.pageNo"
        :page-sizes="[5, 10, 20, 50]"
        :page-size="pageConfig.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageConfig.total"
      >
      </el-pagination>
    </div>

    <AddInfo
      :setTitle="dialogTitle"
      :show-status.sync="showAddStatus"
      :formData="formData"
      :callback="getTableData"
      :tableData="tableData"
      v-if="showAddStatus"
    ></AddInfo>
  </div>
</template>

<script>
import globalTag from "../../../components/globalTag"
import AddInfo from "./info/addInfo.vue"

export default {
  components: {
    globalTag,
    AddInfo,
  },
  data() {
    return {
      searchObj: {},
      dialogTitle: "",
      showAddStatus: false,
      formData: {},
      tableData: [],
      // 分页
      pageConfig: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    //查询
    QuerySearch() {
      this.getTableData()
    },
    //清除条件
    clearData() {
      this.searchObj= {}
      this.getTableData()
    },
    handleTableForm(title, id) {
      this.dialogTitle = title
      this.showAddStatus = true

      if (title != "新增") {
        this.$http
          .request({
            url: "/ypt/admin/all/customer/info/get",
            method: "POST",
            data: {
              id,
            },
          })
          .then((res) => {
            if (res.code === 200) {
              this.formData = res.content
            }
          })
      }
    },
    // 删除某一项
    deleteItem(id) {
      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .request({
            url: "/ypt/admin/all/customer/info/deleteById",
            method: "POST",
            data: {
              id,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              this.$message.success("删除成功")
              this.getTableData()
            }
          })
      })
    },
    getTableData() {
      this.$http
        .request({
          url: "/ypt/admin/all/customer/info/findList",
          method: "POST",
          data: {
            pageNo: this.pageConfig.pageNo,
            pageSize: this.pageConfig.pageSize,
            customerName: this.searchObj.name,
            gender: this.searchObj.sex,
            phone: this.searchObj.phone,
            customerType: this.searchObj.customerType,
            elderlyBelongCategory: this.searchObj.elderlyBelongCategory,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (!res.content) {
              this.tableData = []
              this.pageConfig.total = 0
            } else {
              this.tableData = res.content.list || []
              this.pageConfig.total = res.content.count || 0
            }
          }
        })
    },
    // 每页显示条数切换
    handleSizeChange(val) {
      this.pageConfig.pageSize = val
      this.getTableData()
    },
    // 页码切换
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getTableData()
    },
  },
}
</script>

<style lang="less" scoped>
.ele-caozuo {
  width: 20%;
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
}

.operation-btn {
  width: 100%;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
</style>
